export const SET_DRAWER_COLLAPSED = "setDrawerCollapsed";
export const TOGGLE_DRAWER_COLLAPSED = "toggleDrawerCollapsed";
export const SET_BREADCRUMB = "setBreadcrumb";
export const SET_CONNECTED = "setConnected";

export const SET_AUTH = "setAuth";
export const PURGE_AUTH = "purgeAuth";
export const SET_ERROR = "setError";
export const SET_LOADING = "setLoading";
export const SET_LOGOUT_LOADING = "setLogoutLoading";
export const SET_AUTH_REFRESH = "setAuthRefresh";

// Nav
export const GET_LIST_NAV = "getListNav";
export const SET_LIST_NAV = "setListNav";
export const FETCH_LIST_NAV = "fetchListNav";
export const SET_PRIVILEGE = "setPrivilege";
export const PURGE_LIST_NAV = "purgeListNav";
export const UPDATE_ACTIVE_NAV = "updateActiveNav";
export const SET_NAV_LOADING = "setNavLoading";

export const SET_USER = "setUser";

// Lov
export const SET_LOV_ZIPCODE = "setLovZipCode";
export const SET_LOV_LOADING = "setLovLoading";
export const SET_LOV_ERROR = "setLovError";
